// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { IDeviceConfig } from './subscription';

export interface IKey {
  id: number;
  name: string;
  expirationDate: string;
  scope: string;
  uuid: string;
  hasPrivateKey?: boolean;
  hasProtectedKey?: boolean;
  hasPublicKey?: boolean;
}

export interface IDeviceConfigKey extends IKey {
  // the following attribute is only populated by a call to /home/device/<device_id>
  isExpired?: boolean;
}

export interface IKeysResponse {
  success: boolean;
  keys: IKey[];
}

export interface IUserKeys {
  uuids: [];
  keys: [];
}

export function getKeyIndex(config: IDeviceConfig, config_key: string, j, force: boolean) {
    let key_index = -1;
    for (const [l, key_data_entry] of config[config_key][j].key_data.entries()) {
        if (force || !key_data_entry.is_expired) {
            if (key_index < 0 && key_data_entry.scope !== 'recovery') {
                key_index = l;
            } else if (key_data_entry.scope === 'subscription') {
                // subscription always wins
                key_index = l;
            }
        }
    }
    if ( force && key_index < 0) {
        key_index = 0;
    }
    return key_index;
}


